import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChamadoEmpresaInserirRoutingModule } from './chamado-empresa-inserir-routing.module';
import { ChamadoEmpresaInserirComponent } from './chamado-empresa-inserir.component';
import { FormsModule } from '@angular/forms';
import { MessagesModule } from 'primeng/messages';
import { ButtonModule } from 'primeng/button';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  declarations: [
    ChamadoEmpresaInserirComponent
  ],
  imports: [
    CommonModule,
    ChamadoEmpresaInserirRoutingModule,
    FormsModule,
    MessagesModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    TooltipModule

  ]
})
export class ChamadoEmpresaInserirModule { }
